import { apiClient } from '~/lib/api/client';

export type NotificationType =
  | 'cn01.inspector_assigned'
  | 'cn03.approved'
  | 'cn03.rejected';

export type NotificationEntityType = 'cn01_form' | 'cn03_form';

export type NotificationItem = {
  id: string;
  type: NotificationType;
  title: string;
  body: string;
  entityType: NotificationEntityType;
  entityId: string;
  metadata: string | null;
  readAt: string | null;
  createdAt: string;
};

export type NotificationsListResponse = {
  items: NotificationItem[];
  total: number;
  page: number;
  pageSize: number;
  unreadCount: number;
};

export type UnreadCountResponse = {
  unreadCount: number;
};

export type MarkReadResponse = {
  id: string;
};

export type MarkAllReadResponse = {
  updated: number;
};

export type ListNotificationsParams = {
  page?: number;
  pageSize?: number;
  unreadOnly?: boolean;
};

export async function listNotifications(
  params: ListNotificationsParams = {}
): Promise<NotificationsListResponse> {
  const { page = 1, pageSize = 20, unreadOnly } = params;
  const res = await apiClient.get<NotificationsListResponse>('/notifications', {
    params: {
      page,
      pageSize,
      ...(unreadOnly ? { unreadOnly: true } : {}),
    },
  });
  return res.data;
}

export async function getUnreadCount(): Promise<UnreadCountResponse> {
  const res = await apiClient.get<UnreadCountResponse>('/notifications/unread-count');
  return res.data;
}

export async function markNotificationRead(id: string): Promise<MarkReadResponse> {
  const res = await apiClient.patch<MarkReadResponse>(`/notifications/${id}/read`);
  return res.data;
}

export async function markAllNotificationsRead(): Promise<MarkAllReadResponse> {
  const res = await apiClient.patch<MarkAllReadResponse>('/notifications/read-all');
  return res.data;
}
